export const signSubmission = async (
  urlSlug: string,
  publicId: string,
  responses: Record<string, unknown>,
  userType: string,
): Promise<void> => {
  await fetch(`${process.env.REACT_APP_API_URL}/submissions/${urlSlug}/${publicId}/signature?userType=${userType}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ responses }),
    credentials: 'include',
  });
};
